import React from 'react';
import { useForm } from 'react-hook-form';

import { yupResolver } from '@hookform/resolvers/yup';

import * as yup from 'yup';

import { useTranslation } from 'react-i18next';

import { RailzButton } from '@railzai/railz-uikit-react';

import useStyle from './style';

import { FormInput } from 'components/form';

import { View } from 'components/view';

interface FormValue {
  firstName?: string;
  lastName?: string;
}

const validationSchema = yup.object().shape({
  firstName: yup
    .string()
    .required('DASHBOARD_SIGNUP_FIRST_NAME_REQUIRED')
    .min(2, 'DASHBOARD_PROFILE_FIRST_NAME_CRUD_MIN')
    .max(40, 'DASHBOARD_PROFILE_FIRST_NAME_CRUD_MAX')
    .nullable(),
  lastName: yup
    .string()
    .required('DASHBOARD_SIGNUP_LAST_NAME_REQUIRED')
    .min(2, 'DASHBOARD_PROFILE_LAST_NAME_CRUD_MIN')
    .max(40, 'DASHBOARD_PROFILE_LAST_NAME_CRUD_MAX')
    .nullable(),
});

const initialValues: FormValue = {
  firstName: '',
  lastName: '',
};

interface Props {
  onSubmit: (values: any) => Promise<void>;
  isSubmitting: boolean;
}

export default function SetupAccountForm({ onSubmit, isSubmitting }: Props): JSX.Element {
  const classes = useStyle();
  const { t } = useTranslation();

  const { handleSubmit, errors, control } = useForm({
    mode: 'onTouched',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const onSubmitCall = async (values): Promise<void> => {
    onSubmit && onSubmit(values);
  };

  return (
    <View style={{ paddingTop: '16px' }}>
      <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmitCall)}>
        <div className={classes.row}>
          <FormInput
            defaultValue=""
            label="DASHBOARD_SIGNUP_FIRST_NAME_LABEL"
            placeholder="DASHBOARD_SIGNUP_FIRST_NAME_PLACEHOLDER"
            margin="normal"
            fullWidth
            name="firstName"
            errorobj={errors}
            control={control}
            testid="first-name-input"
          />
          <FormInput
            defaultValue=""
            label="DASHBOARD_SIGNUP_LAST_NAME_LABEL"
            placeholder="DASHBOARD_SIGNUP_LAST_NAME_PLACEHOLDER"
            margin="normal"
            fullWidth
            name="lastName"
            errorobj={errors}
            control={control}
            testid="last-name-input"
          />
        </div>

        <RailzButton
          size="large"
          buttonType="submit"
          isDisabled={isSubmitting}
          loading={isSubmitting}
          data-testid="submit"
          label={t('DASHBOARD_SIGNUP_CTA')}
          className={classes.createAccountButton}
        />
      </form>
    </View>
  );
}
